module.exports = __webpack_public_path__ + "static/media/chevron.0f20b89a.svg";